import {
  Instruction,
  InstructionWithButtonGroup,
  InstructionWithContent,
  InstructionWithTextarea,
} from "../../BlockComponent";
import { MyConcernLine, MyGoalLine } from "../common";

export const Content_0_3_A = (isNotPraisedYet: boolean, hasGoal: boolean) => [
  Instruction("typography_0_0_0"),

  ...(hasGoal
    ? [
        InstructionWithContent(
          "typography_goal_0",
          [...MyConcernLine(), ...MyGoalLine()],
          {
            blockId: "현재 목표",
          }
        ),
        InstructionWithButtonGroup(
          `typography_goal_1`,
          [
            {
              translationKey: "네",
              showFromId: "동의",
              hideFromId: "비동의",
            },
            {
              translationKey: "아니요",
              showFromId: "비동의",
              hideFromId: "동의",
            },
          ],
          undefined,
          { blockId: "수정 불필요" }
        ),
        InstructionWithTextarea(`typography_goal_8`, undefined, {
          blockId: "비동의",
        }),
        InstructionWithTextarea(`typography_goal_8_1`, undefined, {
          blockId: "비동의",
        }),
        Instruction("typography_goal_9", {
          blockId: "비동의",
          nextBlockId: "설문",
        }),
        InstructionWithButtonGroup(
          `typography_goal_2`,
          [
            {
              translationKey: "아직 많이 멀어요",
              showFromId: "멂",
              hideFromId: "가까움",
            },
            {
              translationKey: "조금 멀게 느껴져요",
              showFromId: "멂",
              hideFromId: "가까움",
            },
            {
              translationKey: "조금 가깝게 느껴져요",
              showFromId: "가까움",
              hideFromId: "멂",
            },
            {
              translationKey: "이제 꽤 가까워요",
              showFromId: "가까움",
              hideFromId: "멂",
            },
          ],
          undefined,
          { blockId: "동의" }
        ),
        InstructionWithTextarea(`typography_goal_3`, undefined, {
          blockId: "멂",
          nextBlockId: "설문",
        }),
        InstructionWithTextarea(`typography_goal_4`, undefined, {
          blockId: "가까움",
        }),
        InstructionWithButtonGroup(`typography_goal_5`, [
          {
            translationKey: "아직 아니에요",
            showFromId: "도움 필요",
            hideFromId: "도움 불필요",
          },
          {
            translationKey: "할 수 있을 것 같아요",
            showFromId: "도움 불필요",
            hideFromId: "도움 필요",
          },
        ]),
        InstructionWithTextarea(`typography_goal_6`, undefined, {
          blockId: "도움 필요",
          nextBlockId: "설문",
        }),
        InstructionWithTextarea(`typography_goal_7`, undefined, {
          blockId: "도움 불필요",
        }),
      ]
    : []),

  InstructionWithTextarea(
    `typography_1_0_0`,
    { id: "satisfiedPart" },
    { blockId: "설문" }
  ),
  InstructionWithTextarea(`typography_3_0_0`, { id: "suggestion" }),

  // Button group for "현재 건강한 마음을 향한 나의 마음은 어떠한가요?"
  InstructionWithButtonGroup(
    "typography_4_1_0",
    [
      {
        text: "여전히 커요",
        showFromId: "motivationNeedLevel_good",
        hideFromId: "motivationNeedLevel_normal",
      },
      {
        text: "컸다 작았다 해요",
        showFromId: "motivationNeedLevel_normal",
        hideFromId: "motivationNeedLevel_good",
      },
      {
        text: "잘 모르겠어요",
        showFromId: "motivationNeedLevel_normal",
        hideFromId: "motivationNeedLevel_good",
      },
    ],
    { id: "aspirationLevel" }
  ),

  // Button group for "지금 내게 동기부여는 얼마나 필요한가요?"
  InstructionWithButtonGroup(
    "typography_4_2_0",
    [
      {
        text: "항상 필요해요",
        showFromId: "confidenceLevel_good",
        hideFromId: "confidenceLevel_normal",
      },
      {
        text: "가끔 필요할 때가 있어요",
        showFromId: "confidenceLevel_good",
        hideFromId: "confidenceLevel_normal",
      },
      {
        text: "잘 모르겠어요",
        showFromId: "confidenceLevel_good",
        hideFromId: "confidenceLevel_normal",
      },
    ],
    { id: "motivationNeedLevel" },
    { blockId: "motivationNeedLevel_good" }
  ),

  InstructionWithButtonGroup(
    "typography_4_2_0",
    [
      {
        text: "항상 필요해요",
        showFromId: "confidenceLevel_normal",
        hideFromId: "confidenceLevel_good",
      },
      {
        text: "가끔 필요할 때가 있어요",
        showFromId: "confidenceLevel_normal",
        hideFromId: "confidenceLevel_good",
      },
      {
        text: "잘 모르겠어요",
        showFromId: "confidenceLevel_normal",
        hideFromId: "confidenceLevel_good",
      },
    ],
    { id: "motivationNeedLevel" },
    { blockId: "motivationNeedLevel_normal" }
  ),

  // Button group for "현재 프로그램에 대한 내 자신감은 어떠한가요?"
  InstructionWithButtonGroup(
    "typography_4_3_0",
    [
      {
        text: "잘 해낼 수 있을 거예요",
        ...(isNotPraisedYet
          ? {
              showFromId: "리뷰 요청",
              hideFromId: "마무리",
            }
          : {
              showFromId: "마무리",
              hideFromId: "리뷰 요청",
            }),
      },
      {
        text: "해볼 만한 것 같아요",
        ...(isNotPraisedYet
          ? {
              showFromId: "리뷰 요청",
              hideFromId: "마무리",
            }
          : {
              showFromId: "마무리",
              hideFromId: "리뷰 요청",
            }),
      },
      {
        text: "아직 걱정이 앞서요",
        showFromId: "마무리",
        hideFromId: "리뷰 요청",
      },
    ],
    { id: "confidenceLevel" },
    { blockId: "confidenceLevel_good" }
  ),
  InstructionWithButtonGroup(
    "typography_4_3_0",
    [
      {
        text: "잘 해낼 수 있을 거예요",
        showFromId: "마무리",
        hideFromId: "리뷰 요청",
      },
      {
        text: "해볼 만한 것 같아요",
        showFromId: "마무리",
        hideFromId: "리뷰 요청",
      },
      {
        text: "아직 걱정이 앞서요",
        showFromId: "마무리",
        hideFromId: "리뷰 요청",
      },
    ],
    { id: "confidenceLevel" },
    { blockId: "confidenceLevel_normal" }
  ),

  ...(isNotPraisedYet
    ? [
        Instruction("typography_4_0_0_1_1", { blockId: "리뷰 요청" }),
        Instruction("typography_4_0_0_2"),
        InstructionWithContent("typography_4_0_0_3", [
          [
            {
              type: "buttonLink",
              content: {
                text: "더 알아보기",
                url: "https://orwell.distancing.im/review-event",
              },
            },
          ],
        ]),
        InstructionWithContent("typography_4_0_0_4", [
          [{ type: "storeReview", content: {} }],
        ]),
        InstructionWithContent("typography_4_0_0_5", [
          [
            {
              type: "buttonLink",
              content: {
                text: "고객센터 바로가기",
                url: "https://distancing.channel.io",
              },
            },
          ],
        ]),
      ]
    : []),
  Instruction("typography_5_0_0", { blockId: "마무리" }),
];
